import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { DivisionService } from 'src/app/services/division.service';

@Component({
  selector: 'app-subdivisionlevelpopup',
  templateUrl: './subdivisionlevelpopup.component.html',
  styleUrls: ['./subdivisionlevelpopup.component.scss']
})
export class SubdivisionlevelpopupComponent implements OnInit {
  result: any;
  financial: any;
  goid: any;
  scheme: any;
  component: any;
  product: any;
  financialYear: any;
  schemaId: any;
  division: any;
  divisionId: any;
  componentcode: any;
  productcode: any;
  goidcode: any;
  statetargetlist: any[];
  totalList: any[];

  constructor(
    public dialogRef: MatDialogRef<SubdivisionlevelpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public addServiceDialog: MatDialog,
    private divisionService: DivisionService,
  ) { 
    this.financial=this.dataRecievedData.financialyear,
    this.financialYear=this.dataRecievedData.financialyearcode

    this.goid=this.dataRecievedData.goid,
    this.goidcode=this.dataRecievedData.goidcode,

    this.scheme=this.dataRecievedData.scheme,
    this.schemaId=this.dataRecievedData.schemecode,


    this.component=this.dataRecievedData.component,
    this.componentcode=this.dataRecievedData.componentcode,

    this.product=this.dataRecievedData.product,
    this.productcode=this.dataRecievedData.productcode,

    this.division=this.dataRecievedData.division,
    this.divisionId=this.dataRecievedData.divisioncode
  }

  ngOnInit(): void {
    this.subdivision();
    this.subdivisionpopup();

  }
  cancel()
  {
    this.dialogRef.close();
  }
  subdivision()
  {
    //departmentneed
  this.divisionService.getdbtstatetargetmapping(true, this.financialYear,1,this.goid, this.schemaId,this.component).subscribe(res => {
    this.result = res;
  })
}
subdivisionpopup()
{
  this.divisionService.subdivision(this.financialYear, this.goidcode, this.schemaId, this.componentcode, this.productcode,this.divisionId, true).subscribe(res => {
    this.statetargetlist = [];
    this.statetargetlist = res;
    this.totalList = [{
      bold:1,
      communityTypeName: "Total",
      genderTypeName: "",
      subsidyAmount: _.sumBy(res, 'subsidyAmount'),
      totalMachinery: _.sumBy(res, 'totalMachinery')
    }]

    if (res.length > 0) {
      this.statetargetlist.push(this.totalList[0]);
    }
    this.statetargetlist = res;

  })
}
}